<template>
  <div style="text-align:center;padding: 16px;">Loading...</div>
</template>

<script>
export default {};
</script>